import { doc, getDoc, setDoc } from 'firebase/firestore';
import { auth, db } from '@/services/firebase/firebase';
import type { UserSettings } from '@/types/firebase/settings';

// Re-export types for convenience
export type { UserSettings } from '@/types/firebase/settings';

const settingsDocRef = () => doc(db, 'settings', auth.currentUser!.uid);

export const getSettings = async (): Promise<UserSettings | undefined> => {
  const snap = await getDoc(settingsDocRef());
  return snap.exists() ? (snap.data() as UserSettings) : undefined;
};

export const saveSettings = async (data: Partial<UserSettings>) => {
  await setDoc(settingsDocRef(), data, { merge: true });
}; 